export const USER_STALE_TIME = 60 * 1000 // 1 minute
export const CALENDAR_META_STALE_TIME = 30 * 60 * 1000 // 30 minutes
export const GLOBAL_NOTIFICATIONS_STALE_TIME = 30 * 60 * 1000 // 30 minutes
export const TERMS_AND_CONDITIONS_STALE_TIME = 30 * 60 * 1000 // 30 minutes
